import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import NavigationAlt from "./NavigationAlt";
import { Footer } from "./Footer";
import BioPageImage from "../img/about-page-image.webp";

export const AboutPage = () => {
  return (
    <div data-aos="fade-in">
      <header>
        <NavigationAlt />
      </header>
      <Container fluid className="about-page" as="section">
        <Container>
          <Row>
            <Col sm="12" md="12" lg="5">
              <h2 data-aos="fade-left">My Story</h2>
              <p data-aos="fade-right">
                My journey is certainly a unique one, I am originally from
                Peterborough in Cambridgeshire but have lived and worked in
                London for many years having moved there around 10 years ago to
                attend the BIMM Institute earing a bachelors degree there in
                musical performance. I have also taken time in my life to travel
                around Asia and have lived in Hancock, New York where I was a
                music camp counsellor at French Woods Festival of the Performing
                Arts, upon completing that I went around the USA meeting new
                people, learning new styles of music and growing as both a
                musician and as an individual too.
              </p>
              <div data-aos="fade-up">
                <p className="linkedin-suggestion">
                  <i>
                    Click the button below to see my full background at LinkedIn
                  </i>
                </p>
                <a
                  href="https://www.linkedin.com/in/joshdarby123/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button>Find Out More</Button>
                </a>
              </div>
            </Col>
            <Col sm="12" md="12" lg="2"></Col>
            <Col sm="12" md="12" lg="5">
              <Image
                data-aos="fade-up"
                fluid
                src={BioPageImage}
                alt="Image of Josh playing at a gig"
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </div>
  );
};
